/**
 * Mutations for Vuex
 */

// Private mutations, only available within the store itself
// const privateMutations = {};

// PUblic mutations, available within store and Vue Components
const publicMutations = {
    UPDATE_LANG: "UPDATE_LANG",
    UPDATE_VIEWPORT_INFO: "UPDATE_VIEWPORT_INFO",
    TOGGLE_LANGUAGE_MENU: "TOGGLE_LANGUAGE_MENU"
};

const privateMutations = {
    UPDATE_SCROLL_POS: "UPDATE_SCROLL_POS"
};

// Mutations
const mutations = {
    // Update active language
    [publicMutations.UPDATE_LANG](state, payload) {
        // Check if chosen language exists
        const language = state.languages.findIndex(lang => lang.code === payload.toLowerCase());
        if (language > -1) {
            // Get current active language
            const activeLanguage = state.languages.findIndex(lang => lang.active);
            // Set current active language inactive
            state.languages[activeLanguage].active = false;
            // Set chosen language active
            state.languages[language].active = true;
        }
    },
    [publicMutations.UPDATE_VIEWPORT_INFO](state) {
        state.viewport.height = document.body.scrollHeight;
        state.viewport.scrolled = window.scrollY;
    },
    [publicMutations.TOGGLE_LANGUAGE_MENU](state) {
        state.showLanguageMenu = !state.showLanguageMenu;
    }
};

export {
    mutations as default,
    publicMutations,
    privateMutations
}